export const discontinuedButtonComponent = {
  key: 'discontinuedButtonComponent',
  name: 'Discontinued Button Dept-Component',
  siteIdentifier: 'global',

  discontinuedButtonLabel: 'Discontinued',
};
